import {FC} from 'react';
import {Toggle} from '@rocket-ui/components';
import {
	CARD_COMMISSION_VALUE,
	CARD_REVIEW_COMMISSION_HINT,
	formatCardDisplay,
} from '../../model/cardNumber';
import type {SelectedBank} from '../../model/selectedBank';
import styles from '../AccountReviewStep/AccountReviewStep.module.css';

const PRIMARY_HINT =
	'Эти реквизиты будут использоваться в случае невозможности оплатить по основному способу';

type Props = {
	card: string;
	bank: SelectedBank | null;
	isPrimary: boolean;
	showPrimaryToggle?: boolean;
	onPrimaryChange: (value: boolean) => void;
	error?: string | null;
};

export const CardReviewStep: FC<Props> = ({
	card,
	bank,
	isPrimary,
	showPrimaryToggle = true,
	onPrimaryChange,
	error,
}) => (
	<div className={styles.root}>
		<h2 className={styles.title}>Давайте сверим</h2>

		<dl className={styles.fields}>
			<div className={styles.field}>
				<dt className={styles.label}>Номер карты</dt>
				<dd className={styles.value}>{formatCardDisplay(card)}</dd>
			</div>
		</dl>

		{bank ? (
			<div className={styles.bankRow}>
				{bank.iconUrl ? (
					<img className={styles.bankIcon} src={bank.iconUrl} alt="" />
				) : (
					<span className={styles.bankIconFallback} aria-hidden />
				)}
				<span className={styles.bankName}>{bank.shortName ?? '—'}</span>
			</div>
		) : null}

		<div className={styles.commissionBlock}>
			<div className={styles.field}>
				<p className={styles.label}>Комиссия</p>
				<p className={styles.value}>{CARD_COMMISSION_VALUE}</p>
			</div>
			<p className={styles.commissionHint}>{CARD_REVIEW_COMMISSION_HINT}</p>
		</div>

		{showPrimaryToggle ? (
			<div className={styles.primaryBlock}>
				<div className={styles.primaryRow}>
					<p className={styles.primaryLabel}>Сделать основным способом для получения выплат</p>
					<Toggle value={isPrimary} onChange={onPrimaryChange} />
				</div>
				<p className={styles.primaryHint}>{PRIMARY_HINT}</p>
			</div>
		) : null}

		{error ? <p className={styles.error}>{error}</p> : null}
	</div>
);
